import { render, staticRenderFns } from "./AppFatRefInformation.vue?vue&type=template&id=00ee4ae3&"
import script from "./AppFatRefInformation.vue?vue&type=script&lang=js&"
export * from "./AppFatRefInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports